import { useState } from 'react';
import { ProjectService } from '@softwareone/plugin-project-management-react/src/services';

export const useOrgUsers = (projectService: ProjectService) => {
  const [prevUsersLoading, setPrevUsersLoading] = useState(false);

  const getEmailsUserNames = async () => {
    try {
      setPrevUsersLoading(true);
      const data = projectService.getOrgUsers();
      setPrevUsersLoading(false);
      return data;
    } catch (e) {
      console.error('Fetch error:', e);
      setPrevUsersLoading(false);
    }
  };

  return {
    prevUsersLoading,
    getEmailsUserNames,
  };
};
